import React from 'react';

import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import { School } from 'app/types';

import { navigateTop } from 'common/utils';
import { detailUrl, newDetailUrl } from 'common/utils/conversions';

import style from './SchoolCard.module.scss';
import defaultIcon from 'assets/explore/icon-default.svg';

interface CompProps {
  school: School;
  selected?: string;
}

const SchoolCard = ({ school, selected }: CompProps): React.ReactElement => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isActive = school.id.toString() == selected;
  const url = detailUrl('schools', school.id, school.name);
  const newUrl = newDetailUrl('schools', school.id, school.name);

  return (
    <div
      className={`card ${style.schoolCard} ${isActive && style.active}`}
      key={school.id}
      onClick={() => (isMobile ? null : (navigate(url), navigateTop(0, 0, 'detailContainer')))}
    >
      <div className={style.header}>
        <img className={style.avatar} src={school.logo || defaultIcon} />
        <div className={style.info}>
          <div className={style.name}>{school.name}</div>
          <div className={style.location}>
            <i className="bi bi-geo-alt"></i>
            {school.city.name}, {school.city.country.name}
          </div>
        </div>
      </div>
      <div className={style.body}>
        <div className={style.tagContainer}>
          {school.tags.map((tag) => (
            <div className={style.tag} key={tag.id}>
              {tag.name}
            </div>
          ))}
        </div>
      </div>
      {isMobile && (
        <div className={style.actions}>
          <button className="btn btn-primary" onClick={() => navigate(newUrl)}>
            See details
          </button>
        </div>
      )}
    </div>
  );
};

export default SchoolCard;
